export const initialStateTripRecords = {
    tripRecords: [],
    loading: false,
    errorMessage: null,
};

export const TripRecordsReducer = (state = initialStateTripRecords, action) => {
    switch (action.type) {
        case 'REQUEST_GET_TRIP_RECORDS':
        case 'REQUEST_CREATE_TRIP_RECORD':
        case 'REQUEST_EDIT_TRIP_RECORD':
        case 'REQUEST_DELETE_TRIP_RECORD':
            return {
                ...state,
                loading: true,
                errorMessage: null,
            };

        case 'GET_TRIP_RECORDS_SUCCESS':
            return {
                ...state,
                loading: false,
                tripRecords: action.payload,
            };

        case 'CREATE_TRIP_RECORD_SUCCESS':
        case 'EDIT_TRIP_RECORD_SUCCESS':
        case 'DELETE_TRIP_RECORD_SUCCESS':
            return {
                ...state,
                loading: false,
            };

        case 'GET_TRIP_RECORDS_ERROR':
        case 'CREATE_TRIP_RECORD_ERROR':
        case 'EDIT_TRIP_RECORD_ERROR':
        case 'DELETE_TRIP_RECORD_ERROR':
            return {
                ...state,
                loading: false,
                errorMessage: action.error,
            };

        case 'RESET_TRIP_RECORDS':
            return initialStateTripRecords;

        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
